var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Completed/Normal/Darkblue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.4086,17.0531 C7.1396,17.0531 6.8816,16.9451 6.6926,16.7511 L0.2836,10.1731 C-0.1014,9.7781 -0.0934,9.1441 0.3026,8.7591 C0.6986,8.3731 1.3296,8.3821 1.7166,8.7781 L7.3196,14.5291 L18.2076,0.3901 C18.5426,-0.0479 19.1726,-0.1299 19.6106,0.2081 C20.0476,0.5451 20.1286,1.1731 19.7916,1.6111 L8.2006,16.6631 C8.0236,16.8931 7.7566,17.0341 7.4666,17.0511 C7.4476,17.0521 7.4276,17.0531 7.4086,17.0531",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FICC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subscription---open-accordion-Copy-11",
    transform: "translate(-950.000000, -458.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(443.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Completed/Normal",
    transform: "translate(505.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 3.000000)",
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Fill-1",
    fill: "#053754",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tint/Green",
    mask: "url(#mask-2)",
    fill: "#09B89D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -3.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25,
    height: 25
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick_green.9405794e39bb415e85f9a57490375d72.svg";
export { ForwardRef as ReactComponent };